import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-servicios-soluciones',
  templateUrl: './servicios-soluciones.component.html',
  styleUrls: ['./servicios-soluciones.component.css']
})
export class ServiciosSolucionesComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

}
